import { CardType } from 'types/deck'
import { Option } from 'components/elements/ArchidektDropdown/types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import ManaSymbol from 'components/misc/customIcons/ManaSymbol'
import PhatButton from 'components/formElements/PhatButton'
import Icon from 'components/elements/Icon'

import { getCardCMC } from 'utils/GetCardCMC'

import styles from './customCmcDropdown.module.scss'

type Props = {
  card: CardType
  onCardUpdate: (updatedCard: CardType) => void
  multiEdit?: boolean
  disabled?: boolean
}

const CustomCmcDropdown = ({ card, onCardUpdate, multiEdit, disabled }: Props) => {
  const currentCMC = getCardCMC(card)

  const OPTIONS: Option[] = Array.from(Array(16).keys()).map(cmc => ({
    label: <ManaSymbol symbol={cmc} />,
    id: `${cmc}`,
    onClick: () => onCardUpdate({ ...card, customCmc: cmc }),
  }))

  return (
    <div className={styles.container}>
      <ArchidektDropdown
        options={OPTIONS}
        menuClassName={styles.menu}
        triggerClassName={styles.fullWidth}
        disabled={disabled}>
        <PhatButton className={styles.dropdownTrigger} disabled={disabled}>
          <ManaSymbol symbol={currentCMC} />
          <span style={{ color: currentCMC !== card.cmc ? '#fa890d' : '' }}>Custom MV</span>
          <Icon name="dropdown" />
        </PhatButton>
      </ArchidektDropdown>

      <PhatButton
        onClick={() => onCardUpdate({ ...card, customCmc: null })}
        icon="close"
        disabled={card.customCmc === null || disabled}
        className={styles.clearButton}
      />
    </div>
  )
}

export default CustomCmcDropdown
